export function numDifferentiation(value, upto = 2) {
  let x = Math.sign(value); // 1 for positive and -1 for negative
  var val = Math.abs(value);
  if (value != 0) {
    // if (val >= 10000000) {
    //   return (val / 10000000).toFixed(upto) * x + " Cr";
    // } else
    if (val >= 100000) {
      return numberFormat((val / 100000).toFixed(upto) * x) + " L";
    }
    // else if (val < 100000) {
    //   return (val / 1000).toFixed(upto) * x + " K";
    // }
    else {
      return numberFormat(val.toFixed(upto) * x);
    }
  } else {
    return 0;
  }
}

export function numDifferentiationWithoutSymbol(value) {
  let x = Math.sign(value); // 1 for positive and -1 for negative
  var val = Math.abs(value);
  if (value != 0) {
    // if (val >= 10000000) {
    //   return (val / 10000000).toFixed(upto) * x + " Cr";
    // } else
    // if (val >= 1000) {
    return numberFormat((val / 100000).toFixed(2) * x);
    // }
    // else if (val < 100000) {
    //   return (val / 1000).toFixed(upto) * x + " K";
    // }
    // else {
    //   return val.toFixed(2) * x;
    // }
  } else {
    return 0;
  }
}

export function forToFix(value) {
  let y = Math.sign(value);
  var val = Math.abs(value) * y;
  val = val.toFixed(2);
  return val;
}

// export function aboveHundredCr(value) {
//   let x = Math.sign(value); // 1 for positive and -1 for negative
//   var val = Math.abs(value);
//   if (val != 0) {
//     if (val >= 1000000000) {
//       val = (val / 10000000).toFixed(2) * x + " Cr";
//       return val;
//     } else {
//       const val1 = val.toFixed(1) * x;
//       return numberFormat(val1);
//     }
//   } else {
//     return 0;
//   }
// }
// export const numberFormat = (val) => {
//   if (val.toString().length > 4) {
//     const NumberWithComma = new Intl.NumberFormat("en-IN").format(val);
//     return NumberWithComma;
//   } else {
//     return val.toString();
//   }
// };

export const numberFormat = (val) => {
  val = val.toString();
  let SignBool = val.startsWith("-");
  const value1 = val.substring(0, val.indexOf("."));
  if ((SignBool && value1.length > 5) || (!SignBool && value1.length > 4)) {
    const NumberWithComma = new Intl.NumberFormat("en-IN").format(val);
    return NumberWithComma;
  } else {
    return val?.toString();
  }
};

export function aboveOneLacs(value) {
  let x = Math.sign(value); // 1 for positive and -1 for negative
  var val = Math.abs(value);
  if (val != 0) {
    if (val >= 100000) {
      val = (val / 100000).toFixed(2) * x + " L";
      return val;
    } else {
      const val1 = val.toFixed(1);
      return numberFormat(val1);
    }
  } else {
    return 0;
  }
}
